import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const QuickAccessSection = () => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: 1,
      title: "Meu Progresso",
      description: "Acompanhe seu desenvolvimento",
      icon: "TrendingUp",
      color: "bg-success",
      path: "/user-progress-dashboard"
    },
    {
      id: 2,
      title: "Atividades",
      description: "Complete exercícios e avaliações",
      icon: "CheckSquare",
      color: "bg-secondary",
      path: "/activity-interface"
    },
    {
      id: 3,
      title: "Novidades", //"Mentor Dai",
      description: "Em Breve", //"Converse com seu assistente IA",
      icon: "MessageCircle",
      color: "bg-accent",
      path: "/" //"/ai-chat-interface-dai-mentor"
    },
    {
      id: 4,
      title: "Biblioteca",
      description: "Acesse recursos adicionais",
      icon: "Library",
      color: "bg-primary",
      path: "/course/formacao-lideres-mentores/module/modulo-1-formacao-de-lideres-e-mentores"
    }
  ];

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <section className="mb-12">
      <h2 className="text-2xl font-heading font-semibold text-foreground mb-6">
        Acesso Rápido
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {quickActions?.map((action) => (
          <div
            key={action?.id}
            className="bg-card rounded-lg p-6 shadow-tier-1 hover:shadow-tier-2 transition-all duration-300 cursor-pointer group"
            onClick={() => handleActionClick(action?.path)}
          >
            <div className="flex items-center space-x-4 mb-4">
              <div className={`w-12 h-12 ${action?.color} rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                <Icon 
                  name={action?.icon} 
                  size={20} 
                  color="white"
                />
              </div>
              <div className="flex-1">
                <h3 className="font-heading font-semibold text-card-foreground group-hover:text-primary transition-colors">
                  {action?.title}
                </h3>
              </div>
            </div>
            
            <p className="text-sm text-muted-foreground font-caption mb-4">
              {action?.description}
            </p>

            <Button
              variant="ghost"
              iconName="ArrowRight"
              iconPosition="right"
              className="w-full justify-between text-muted-foreground hover:text-primary"
            >
              Acessar
            </Button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default QuickAccessSection;